// @flow
import React from "react";
import type {GenericModalDispatchProps, GenericModalStateProps} from "../../../components/GenericModal";
import GenericModal from "../../../components/GenericModal";
import type {StoreState} from "../../../reducers/combinedReducers";
import {Dispatch} from "redux";
import {closeBulkDeleteEBadgePhotoModalAction, photoEBadgeBulkDeleteAction} from "../../../actions/ebadge/photo/creators/photoEBadgeActionCreator";
import {connect} from "react-redux";
import {extractCaller} from "../../QueryPage";

function mapStateToProps(state: StoreState): GenericModalStateProps {

    const isLoading = state.photoEBadgeAction.del.bulk.isLoading;

    const error = state.photoEBadgeAction.del.bulk.error;

    return {
        promptMsg: `Confirm to delete selected photo(s)?`,
        loadingMsg: `OK. We are deleting the photo(s).`,
        open: state.modal.bulkDeletePhoto.open,
        isLoading,
        error,
        primaryActionText: `Delete`,
        args: {
            registrationCodes: state.photoEBadgeAction.del.bulk.registrationCodes,
            caller: extractCaller(state)
        },
        primaryActionColor: 'danger'
    }
}

function mapDispatchToProps(dispatch: Dispatch): GenericModalDispatchProps {

    return {
        primaryAction: (args: any) => {
            dispatch(photoEBadgeBulkDeleteAction(args.registrationCodes, args.caller));
        },
        closeModal: () => {
            dispatch(closeBulkDeleteEBadgePhotoModalAction())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GenericModal);


// WEBPACK FOOTER //
// ./src/containers/ebadge/photo/BulkDeleteModal.js